import { Link } from "react-router-dom";
import { Phone, Video, Clock } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
      <div className="mb-8">
        <span className="dg-eyebrow">About</span>
        <h1 className="mt-2 font-display text-3xl sm:text-5xl font-extrabold">Real tech help, one call away.</h1>
      </div>
      <div className="dg-card rounded-2xl p-6 sm:p-8">
        <p className="text-slate-300 leading-relaxed">Dr.Gadget is David — a tech generalist with real hands-on A/V, security camera and networking experience. Most problems he fixes by phone or video: you call or hop on Zoom, FaceTime or Google Meet, point the camera at the problem, and you fix it together. No call-center runaround, no waiting all day for a truck.</p>
        <p className="text-slate-300 leading-relaxed mt-4">And when something needs hands — a TV mounted, cameras installed, surround sound wired — David comes to you anywhere in the Los Angeles area. Call or <Link to="/ask?type=install" className="dg-link">request an installation quote</Link>.</p>
      </div>

      <div className="dg-card rounded-2xl overflow-hidden mt-6">
        <img src="/dr-gadget-van.jpg" alt="The Dr.Gadget van — Networking, Surround Sound, Audio/Video Systems, Surveillance" className="w-full h-64 sm:h-80 object-cover object-[50%_45%]" data-testid="about-van-photo" />
        <div className="p-5">
          <div className="dg-eyebrow">The Dr.Gadget van</div>
          <p className="text-sm text-slate-300 mt-1">Years of networking, surround sound, A/V and surveillance installs across LA — and the van still rolls for in-person installations in the Los Angeles area.</p>
        </div>
      </div>

      <div className="grid gap-4 sm:grid-cols-3 mt-6">
        <div className="dg-card rounded-xl p-5"><Phone className="w-5 h-5 text-cyan-400" /><div className="mt-3 dg-eyebrow">Call</div><a href="tel:+13104220669" className="dg-link block mt-1 font-mono">310-422-0669</a></div>
        <div className="dg-card rounded-xl p-5"><Video className="w-5 h-5 text-cyan-400" /><div className="mt-3 dg-eyebrow">How we meet</div><div className="mt-1 text-slate-200">Phone · Zoom · FaceTime · Google Meet · In person (LA area)</div></div>
        <div className="dg-card rounded-xl p-5"><Clock className="w-5 h-5 text-cyan-400" /><div className="mt-3 dg-eyebrow">Hours</div><div className="mt-1 text-slate-200">Mon–Sat · 8am–7pm</div></div>
      </div>

      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/book" className="dg-btn-primary rounded-full px-5 py-2 text-sm" data-testid="about-book-btn">Book a Session</Link>
        <Link to="/ask" className="dg-btn-ghost rounded-full px-5 py-2 text-sm">Ask Dr.Gadget</Link>
      </div>
    </div>
  );
}
